import React, { useState } from "react";
import { Container, Grid, Stack } from "@mui/material";
import ExpenseForm from "../components/ExpenseForm";
import ExpenseList from "../components/ExpenseList";
import FinancePageHeader from "../components/finance/FinancePageHeader";
import DashboardLayout from "../components/Layout/DashboardLayout";
import { useAuth } from "../context/AuthContext";

const ExpensesPage = () => {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <DashboardLayout
      role={user?.role}
      activePage="/expenses"
      title="Gestion des dépenses"
    >
      <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
        <Stack spacing={2.5}>
          <FinancePageHeader
            title="Gestion des dépenses"
            subtitle="Enregistrez les dépenses opérationnelles et consultez l’historique des sorties de caisse."
          />

          <Grid container spacing={2}>
            <Grid item xs={12} lg={5}>
              <ExpenseForm onCreated={() => setRefreshKey((prev) => prev + 1)} />
            </Grid>

            <Grid item xs={12} lg={7}>
              <ExpenseList refreshKey={refreshKey} />
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default ExpensesPage;